export async function copyTextToClipboard(text: string): Promise<boolean> {
    if (typeof navigator !== "undefined" && navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
        const clipboardWrite = navigator.clipboard.writeText(text)
            .then(() => true)
            .catch(() => false);
        // Bare setTimeout, not window.setTimeout: this function feature-detects
        // every browser global it touches, and `window` is absent under SSR.
        let stallTimer: ReturnType<typeof setTimeout> | undefined;
        const didWrite = await Promise.race([
            clipboardWrite,
            new Promise<false>((resolve) => {
                stallTimer = setTimeout(() => resolve(false), 2000);
            }),
        ]);
        if (stallTimer !== undefined) {
            clearTimeout(stallTimer);
        }
        if (didWrite) {
            return true;
        }
        // A denied or stalled Clipboard API call falls through to the
        // synchronous selection-based path below.
    }

    if (typeof document === "undefined" || !document.body) {
        return false;
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    textarea.style.pointerEvents = "none";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
        return document.execCommand("copy");
    } catch {
        return false;
    } finally {
        document.body.removeChild(textarea);
    }
}
